<div class="prefs-sheet">
  <div class="prefs-sheet__header">
    <h2 class="prefs-sheet__title">
      <mat-icon>tune</mat-icon> Préférences
    </h2>
    <button mat-icon-button (click)="close()" aria-label="Fermer">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="prefs-sheet__content">
    <div class="prefs-sheet__group">
      <h3 class="prefs-sheet__label">Notifications</h3>
      <mat-card class="prefs-sheet__alert" *ngIf="!isSubscribedToNotifications() && atLeastOneNotificationChecked()">
        <mat-card-content>Vos notifications ne sont pas actives</mat-card-content>
        <mat-card-actions>
          <button mat-raised-button color="primary" (click)="subscribeToNotifications()" [disabled]="activating">
            {{ activating ? 'Activation…' : 'Activer' }}
          </button>
        </mat-card-actions>
      </mat-card>
      <div class="prefs-sheet__toggle-row">
        <span class="prefs-sheet__toggle-label">
          Newsletter
          <mat-icon matTooltip="Envoyée par email pour vous tenir informé" matTooltipPosition="above"
                    (click)="showTooltip(tooltip1)" #tooltip1="matTooltip" class="prefs-sheet__help">help_outline</mat-icon>
        </span>
        <mat-slide-toggle [(ngModel)]="notificationsService.notifications.receiveNewsletter" color="accent"
                          (ngModelChange)="changeNotificationsReceive()"></mat-slide-toggle>
      </div>
      <div class="prefs-sheet__toggle-row">
        <span class="prefs-sheet__toggle-label">
          Importantes
          <mat-icon matTooltip="Consultations, AG et documents officiels" matTooltipPosition="above"
                    (click)="showTooltip(tooltip2)" #tooltip2="matTooltip" class="prefs-sheet__help">help_outline</mat-icon>
        </span>
        <mat-slide-toggle [(ngModel)]="notificationsService.notifications.receiveImportantNotifications" color="accent"
                          (ngModelChange)="changeNotificationsReceive()"></mat-slide-toggle>
      </div>
      <div class="prefs-sheet__toggle-row">
        <span class="prefs-sheet__toggle-label">
          Vie associative
          <mat-icon matTooltip="Projets, rencontres, appels à bénévoles..." matTooltipPosition="above"
                    (click)="showTooltip(tooltip3)" #tooltip3="matTooltip" class="prefs-sheet__help">help_outline</mat-icon>
        </span>
        <mat-slide-toggle [(ngModel)]="notificationsService.notifications.receiveAssociativeNotifications" color="accent"
                          (ngModelChange)="changeNotificationsReceive()"></mat-slide-toggle>
      </div>
      <div class="prefs-sheet__toggle-row">
        <span class="prefs-sheet__toggle-label">
          Suggestions
          <mat-icon matTooltip="Création, envoi au CA..." matTooltipPosition="above"
                    (click)="showTooltip(tooltip4)" #tooltip4="matTooltip" class="prefs-sheet__help">help_outline</mat-icon>
        </span>
        <mat-slide-toggle [(ngModel)]="notificationsService.notifications.receiveSuggestionNotifications" color="accent"
                          (ngModelChange)="changeNotificationsReceive()"></mat-slide-toggle>
      </div>
      <div class="prefs-sheet__toggle-row">
        <span class="prefs-sheet__toggle-label">Pronostics</span>
        <mat-slide-toggle [(ngModel)]="notificationsService.notifications.receivePronoNotifications" color="accent"
                          (ngModelChange)="changeNotificationsReceive()"></mat-slide-toggle>
      </div>
    </div>

    <mat-divider></mat-divider>

    <div class="prefs-sheet__group">
      <h3 class="prefs-sheet__label">Vitesse de la barre d'info</h3>
      <mat-radio-group [(ngModel)]="currentTickerSpeed" (change)="onTickerSpeedChange(currentTickerSpeed)"
                       class="prefs-sheet__radio-group">
        <mat-radio-button [value]="NewsTickerSpeed.SLOW" color="accent">Lent</mat-radio-button>
        <mat-radio-button [value]="NewsTickerSpeed.NORMAL" color="accent">Normal</mat-radio-button>
        <mat-radio-button [value]="NewsTickerSpeed.FAST" color="accent">Rapide</mat-radio-button>
      </mat-radio-group>
    </div>
  </div>
</div>
